import { fetchFromAPI } from 'utils/api';

export const getMyScheduleCounts = () => {
  return fetchFromAPI('/my_schedule/counts')
    .then((response) => response.resources)
    .catch((response) => {
      throw response;
    });
};

export const fetchScheduledTreatments = (params) => {
  return fetchFromAPI('/my_schedule/treatments', { params })
    .catch((response) => {
      throw response;
    });
};

export function applyScheduledTreatmentsFilter(params) {
  return fetchFromAPI('/my_schedule/treatments/filter', { method: 'post', body: JSON.stringify(params) })
    .catch((response) => {
      throw response;
    });
}
